import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const DashboardAPI = createApi({
  reducerPath: "DashboardAPI",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    checkPageInPms: builder.mutation({
      query: (pageNames) => ({
        url: "v1/check_page_in_pms",
        method: "POST",
        body: { page_names: pageNames },
      }),
    }),
    getAllUnfetchedPages: builder.query({
      query: () => {
        return "v1/get_all_not_available_pages";
      },
      transformResponse: (response) =>
        response?.data?.reverse()?.filter((item) => item?.page_exist === false),
    }),
    updateUnfetchedPage: builder.mutation({
      query: ({ page, new_value }) => ({
        url: "v1/update_unfetched_pages",
        method: "PUT",
        body: { page, new_value },
      }),
    }),

    getSubCategoriesByCategoryId: builder.query({
      query: (categoryId) => {
        return `v1/get_all_sub_cat_with_cat_id/${categoryId}`;
      },
      transformResponse: (response) =>
        response?.data?.map((subCat) => ({
          value: subCat.page_sub_category_id,
          label: subCat.page_sub_category_name,
        })) ?? [],
    }),
    addPageCatAssignment: builder.mutation({
      query: (payload) => ({
        url: "v1/add_page_cat_assignment",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useCheckPageInPmsMutation,
  useGetAllUnfetchedPagesQuery,
  useUpdateUnfetchedPageMutation,
  useGetSubCategoriesByCategoryIdQuery,
  useAddPageCatAssignmentMutation,
} = DashboardAPI;
export default DashboardAPI;
